import { Link } from "react-router-dom";
import { ArrowRight, FileText, Key, TrendingUp, Home as HomeIcon, Shield, AlertTriangle } from "lucide-react";

const FACTS = [
  {
    icon: FileText,
    title: "You may still receive a utility bill",
    desc: "Most homes still draw from the grid at night or during low-production months. Your utility bill continues alongside your Power Purchase Agreement — the PPA covers the solar portion only.",
  },
  {
    icon: Key,
    title: "ION Solar owns the equipment under the PPA",
    desc: "The system owner installs, maintains, monitors, and insures the equipment. You purchase the clean energy it produces at the contract rate.",
  },
  {
    icon: TrendingUp,
    title: "The annual escalator is defined in the agreement",
    desc: "Your energy rate adjusts by a fixed percentage each year as specified in the signed agreement. The exact escalator figure is on the PPA comparison section.",
  },
  {
    icon: HomeIcon,
    title: "If you sell, the agreement travels with the home",
    desc: "The PPA may be assumed by an eligible buyer, and warranties and guarantees are inherited by the new homeowner per their terms.",
  },
  {
    icon: Shield,
    title: "What the production guarantee covers",
    desc: "The system is backed by a 25-year production guarantee. Eligible production shortfalls may receive compensation according to the written agreement.",
  },
  {
    icon: AlertTriangle,
    title: "Some homes may not be a good fit",
    desc: "Heavy shading, a roof near end-of-life, structural concerns, or limited southerly exposure can make solar impractical. I'll tell you directly if that's the case.",
  },
];

export default function TransparencyFacts() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="transparency-facts-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">Clear & Straight</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C] leading-tight">
            Six things worth knowing before you ask.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg">
            Plain-language facts about how a residential solar PPA actually works. For the exact figures and term lengths, see the PPA comparison on <Link to="/how-solar-works" className="text-[#B45309] underline underline-offset-4 hover:text-[#0F382C]">How Solar Works</Link>.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FACTS.map((f) => (
            <div key={f.title} className="card-warm p-6">
              <div className="w-11 h-11 rounded-xl bg-[#D97706]/15 border border-[#D97706]/25 flex items-center justify-center">
                <f.icon className="w-5 h-5 text-[#B45309]" />
              </div>
              <h3 className="mt-4 font-serif-display text-lg text-[#0F382C] leading-snug">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/how-solar-works" className="btn-ghost-forest text-sm" data-testid="transparency-ppa-link">
            See the PPA comparison <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/homeowner-questions" className="btn-solar text-sm" data-testid="transparency-questions-link">
            More homeowner questions <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
